import React from "react";
import Colors from "../../constants/Colors";
import { getPercentString, calculatePercent } from "../../lib/StringHelper";

interface ProgressBarProps {
  fraction: number;
}

const ProgressBar = (props: ProgressBarProps) => {
  const { fraction } = props;
  const computedStyle = {
    ...styles.progressBar,
    width: getPercentString(calculatePercent(fraction)),
  };
  return <div style={computedStyle} />;
};

const styles = {
  progressBar: {
    backgroundColor: Colors.green,
    height: "5px",
  },
};
export default ProgressBar;
